<template>
  <div class="flex items-start border-solid rounded p-4 cursor-pointer"
    :class="{
      'border-green border-2': modelValue,
      'border-grey-300 border': !modelValue,
    }"
    :style="{
      'padding': modelValue ? '15px' : '16px',
    }"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <slot name="icon" />
    <div class="ml-2 grow">
      <div class="font-semibold mb-2">
        {{ title }}
      </div>

      <div class="text-xs">
        {{ content }}
      </div>
    </div>
    <CheckboxField
      size="large"
      :model-value="modelValue"
      class="pointer-events-none ml-2"
      :data-test-id="testId"
    />
  </div>
</template>
<script>
import CheckboxField from '@/components/Ui/Forms/CheckboxField.vue';

export default {
  name: 'BoxFilterSection',
  emits: ['update:modelValue'],
  components: {
    CheckboxField,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    testId() {
      return `more__filters-${this.id}`;
    },
  },
};
</script>
